<form [formGroup]="salesJobTypeForm">
  <div class="row">
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="jobTypeList() ?? []"
        [label]="'Job Type'"
        [allowSearch]="true"
        [clearable]="true"
        [required]="true"
        [placeholder]="'Select Job Type'"
        [errormessage]="'Job Type is required'"
        formControlName="jobTypeId"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="revenueMajorCodeList()"
        [label]="'Revenue Major Code'"
        [allowSearch]="true"
        [clearable]="true"
        [required]="true"
        [placeholder]="'Select Revenue Major Code'"
        [errormessage]="'Revenue Major Code is required'"
        formControlName="revenueMajorCodeId"
      >
      </generic-dropdown>
    </div>

    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="minorCodeList()"
        [label]="'Revenue Minor Code'"
        [allowSearch]="true"
        [clearable]="true"
        [required]="true"
        [placeholder]="'Select Revenue Minor Code'"
        [errormessage]="'Revenue Minor Code is required'"
        formControlName="revenueMinorCodeId"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6 mb-3">
      <generic-dropdown
        [items]="minorCodeList()"
        [label]="'Cost Minor Code'"
        [allowSearch]="true"
        [clearable]="true"
        [required]="true"
        [placeholder]="'Select Cost Minor Code'"
        [errormessage]="'Cost Minor Code is required'"
        formControlName="costMinorCodeId"
      >
      </generic-dropdown>
    </div>
    <label for="autoUpdate">Auto Update</label>
    <div class="col-lg-6 mb-3"><p-toggleswitch formControlName="autoUpdate"></p-toggleswitch></div>
  </div>
</form>
